import React, {createContext, useEffect, useState} from 'react';

const NetworkStatusContext = createContext(true);

const NetworkStatusProvider = ({children}) => {

  const [isOnline, setIsOnline] = useState(true);

  function onOffline() {
    setIsOnline(false);
  }
  function onOnline() {
    setIsOnline(true);
  }

  useEffect(() => {
    window.addEventListener('offline', onOffline);
    window.addEventListener('online', onOnline);

    return () => {
      window.removeEventListener('offline', onOffline);
      window.removeEventListener('online', onOnline);
    };
  }, []);

  return (
    <NetworkStatusContext.Provider value={isOnline}>
      {children}
    </NetworkStatusContext.Provider>
  );
};

export {NetworkStatusProvider, NetworkStatusContext};
